<div class="modal-body width-600 height-800">
  <div class="layout-auto-1-auto">
    <span class="modal-header">{{getRessource('SelectAttachments')}}
    </span>
    <div class="content">
      <div class="layout-auto-1-auto">
        <div>
          <div (filesSelect)="onFilesSelected($event)"
               [multiple]="true"
               [dnd]="true"
               class="app-drag-drop" appExgDirectUploadV2>
            {{getResource('FileDropText')}}
          </div>
          <exg-chips listdisplay="dokName" [list]="attachmentObjects"
                     (ItemClose)="onAttachmentFileChipClose($event)"></exg-chips>
        </div>
        <div class="content">
          <div style="font-weight: 500; padding: 0.5rem;">{{getGlobal('Attachments')}}</div>
          <cdk-tree [dataSource]="ConfigAttachmentTable.dataSource" [treeControl]="ConfigAttachmentTable.treeControl">
            <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: ConfigAttachmentTable.hasChild" class="example-tree-node">
              <div class="list-row app-cursor-pointer" cdkTreeNodeToggle>
                <div class="grid-auto-1" style="padding:0.5rem">
                  <div class="list-avatar nobackground">
                    <i class="far fa-fw"
                       [class.fa-folder-open]="ConfigAttachmentTable.treeControl.isExpanded(node)"
                       [class.fa-folder]="!ConfigAttachmentTable.treeControl.isExpanded(node)">
                    </i>
                  </div>
                  <div class="layout-1-auto">
                    <div class="list-metadata" style="margin-left:0">
                      {{node.dokFolderCount}} {{getRessource(node.source + 'Count')}}
                    </div>
                    <div>
                      <ng-container *ngIf="node.source === 'document'">
                        {{enumSvc.getEnumerationText('DokTyp', node.dok_enmIdent_DokTyp)}}
                      </ng-container>
                      <ng-container *ngIf="node.source === 'report'">
                        {{getRessource('reportFolder')}}
                      </ng-container>
                      <ng-container *ngIf="node.source === 'Fragebogen'">
                        {{getRessource('questionnaireFolder')}}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div [hidden]="!ConfigAttachmentTable.treeControl.isExpanded(node)">
                <ng-container cdkTreeNodeOutlet></ng-container>
              </div>
            </cdk-nested-tree-node>

            <cdk-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
              <div class="list-row app-cursor-pointer" (click)="toggleSelection(node)">
                <div class="grid-auto-1" style="padding-left: 3rem;">
                  <div class="list-avatar nobackground">
                    <input type="checkbox" [checked]="isSelected(node)">
                  </div>
                  <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                    <div class="list-metadata" style="margin-left:0">
                      <div>
                        <ng-container *ngIf="node.linked">
                          <span flow="left" style="font-size: medium"
                                [tooltip]="getRessource('tooltip.linked')">
                            <i class="fal fa-link"></i>
                            <ng-container *ngIf="!node.dokTrackingPortalShare">
                              &nbsp;-&nbsp;
                            </ng-container>
                          </span>
                        </ng-container>
                        <ng-container *ngIf="node.dokTrackingPortalShare">
                          <span flow="left" style="font-size: medium"
                                [tooltip]="getRessource('tooltip.trackingPortal')">
                            <i class="far fa-cloud"></i> -
                          </span>
                        </ng-container>
                        {{node.dok_enmIdent_DokTyp >= 0 && node.dokGroesse > 0 ? appSvc.file.calcFileSize(node.dokGroesse, false) + ' - ' : ''}}
                        {{node.dokMode}}
                      </div>
                    </div>

                    <div class="list-metadata">
                      <div class="typo-right">{{node.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                      <div class="typo-right">{{node.dokCRU}}</div>
                    </div>
                    <div class="span-2">
                      <div style="overflow: hidden">
                        <strong>{{node.dokName}}{{node.dokErw}}</strong>
                      </div>
                    </div>
                    <div class="span-2 list-secondary-text">{{node.dokBeschreibung}}</div>
                  </div>
                </div>
              </div>
            </cdk-tree-node>
          </cdk-tree>
        </div>
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button (click)="save()" class="md-btn">
        {{getGlobal('Choose')}}
      </button>
    </div>
  </div>
</div>
